import EventLoader from './EventLoader';

export default EventLoader;
